import moment from "moment";
import { create } from "zustand";
import { queryClient } from "../../..";

function addBreaks(slots) {
    let updatedSlots = [];
    for (let i = 0; i < slots.length - 1; i++) {
        let currentSlot = slots[i];
        let nextSlot = slots[i + 1];

        updatedSlots.push(currentSlot);

        let endTime = moment(currentSlot.end_hour, "HH:mm");
        let startTimeNext = moment(nextSlot.start_hour, "HH:mm");
        let diff = startTimeNext.diff(endTime, "minutes");

        if (diff > 0 && nextSlot.status.value !== 4) {
            let durationStr = moment.utc(diff * 60 * 1000).format("HH[H]mm");
            updatedSlots.push({
                id: -i,
                status: {
                    value: -1,
                    value_str: "break",
                },
                duration_str: durationStr,
                start_hour: null,
                end_hour: null,
            });
        }
    }
    updatedSlots.push(slots[slots.length - 1]);
    return updatedSlots;
}

function calculateTotalWorkTime(slots) {
    let totalMinutes = slots.reduce((sum, slot) => {
        let start = moment(slot.start_hour, "HH:mm");
        let end = moment(slot.end_hour, "HH:mm");
        return sum + end.diff(start, "minutes");
    }, 0);

    let hours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
    let minutes = String(totalMinutes % 60).padStart(2, "0");
    return `${hours}h${minutes}`;
}

export const ACTIONS_TIMETABLE = {
    init_reducer: "init_reducer",
    set_timetables: "set_timetables",
    update_slot_day: "update_slot_day",
    toggle_time_reporting_activated: "toggle_time_reporting_activated",
    toggle_geolocation_activated: "toggle_geolocation_activated",
    toggle_auto_correct_hours_activated: "toggle_auto_correct_hours_activated",
    toggle_break_time_alert_activated: "toggle_break_time_alert_activated",
    toggle_badge_activated: "toggle_badge_activated",
    update_break_time_duration_minutes: "update_break_time_duration_minutes",
    toggle_auto_correct_hours_before_minutes:
        "toggle_auto_correct_hours_before_minutes",
    toggle_auto_correct_hours_after_minutes:
        "toggle_auto_correct_hours_after_minutes",
};

export const INIT_REDUCER_ARGS = {};

export const reducer = (state, action) => {
    switch (action.type) {
        case ACTIONS_TIMETABLE.init_reducer: {
            const payload = action.payload;
            return payload;
        }
        case ACTIONS_TIMETABLE.set_timetables: {
            const payload = action.payload;
            return {
                ...state,
                timetable: payload,
            };
        }
        case ACTIONS_TIMETABLE.toggle_geolocation_activated: {
            const checked = action.payload;
            return {
                ...state,
                geolocation_activated: checked,
            };
        }
        case ACTIONS_TIMETABLE.toggle_time_reporting_activated: {
            const checked = action.payload;
            return {
                ...state,
                time_reporting_activated: checked,
            };
        }
        case ACTIONS_TIMETABLE.toggle_auto_correct_hours_activated: {
            const checked = action.payload;
            return {
                ...state,
                auto_correct_hours_activated: checked,
            };
        }
        case ACTIONS_TIMETABLE.toggle_break_time_alert_activated: {
            const checked = action.payload;
            return {
                ...state,
                break_time_alert_activated: checked,
            };
        }
        case ACTIONS_TIMETABLE.toggle_badge_activated: {
            return {
                ...state,
                badge_activated: !state.badge_activated,
            };
        }
        case ACTIONS_TIMETABLE.update_break_time_duration_minutes: {
            return {
                ...state,
                break_time_duration_minutes: action.payload,
            };
        }
        case ACTIONS_TIMETABLE.toggle_auto_correct_hours_before_minutes: {
            return {
                ...state,
                auto_correct_hours_before_minutes: action.payload,
            };
        }
        case ACTIONS_TIMETABLE.toggle_auto_correct_hours_after_minutes: {
            return {
                ...state,
                auto_correct_hours_after_minutes: action.payload,
            };
        }
        case ACTIONS_TIMETABLE.update_slot_day: {
            const day_index = action.payload.day_index;
            const new_slots = action.payload.slots;

            const slotsWithBreaks = addBreaks(
                new_slots.filter((slot) => slot.status.value !== -1)
            );
            const new_duration_str = calculateTotalWorkTime(
                new_slots.filter(
                    (slot) =>
                        slot.status.value !== -1 && slot.status.value !== 4
                )
            );

            const new_state = state.timetable.map((tt) => {
                if (tt.day_idx === day_index) {
                    return {
                        ...tt,
                        shifts: slotsWithBreaks,
                    };
                }
                return tt;
            });

            queryClient.setQueryData(
                "EMPLOYEE_FOLDER::timetable_rh",
                (data) => {
                    const timetable = data.timetable.map((tt) => {
                        if (tt.day_idx === day_index) {
                            return {
                                ...tt,
                                shifts: slotsWithBreaks,
                                duration_str: new_duration_str,
                            };
                        } else {
                            return tt;
                        }
                    });
                    return {
                        ...data,
                        timetable: timetable,
                    };
                }
            );

            return {
                ...state,
                timetable: new_state,
            };
        }

        default: {
            return state;
        }
    }
};

// Créer le store Zustand avec un état initial et un dispatch
export const useStoreTimetable = create((set) => ({
    state: INIT_REDUCER_ARGS,
    dispatch: (action) =>
        set((currentState) => ({
            state: reducer(currentState.state, action),
        })),
}));
